export enum EImportStoreActionType {
  DISCONNECT = 'disconnect',
  SYNC = 'sync',
  CREATE = 'create',
}

export const IMPORT_STORE_ACTION_OPTIONS = [
  { label: 'Skip/Disconnect the listing', value: EImportStoreActionType.DISCONNECT },
  { label: 'Link with existing store', value: EImportStoreActionType.SYNC },
  { label: 'Create as a new store', value: EImportStoreActionType.CREATE },
];
